module.exports = __webpack_public_path__ + "img/line-share-grey.68307f69.svg";